module.exports = __webpack_public_path__ + "img/arrows.c9e6aa8a.svg";